import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import exact from 'prop-types-exact';
import { Button, ButtonToolbar, Clearfix, Glyphicon, Label, Nav, NavItem } from 'react-bootstrap';

import { nodeType } from '../../../propTypes';
import linkWithCredentials from '../../../utils/linkWithCredentials';
import { getFormState } from '../../tickets/components/TicketVariablesEditor';

import MissingTimeEntriesModal, {
  missingTimeEntriesModalPropTypes,
  withMissingTimeEntriesModalState,
} from '../../ticketApprovals/components/MissingTimeEntriesModal';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';

const propTypes = exact({
  tickets: PropTypes.arrayOf(nodeType).isRequired,
  job: nodeType.isRequired,
  selectedTicketId: PropTypes.number.isRequired,
  selectTicketId: PropTypes.func.isRequired,
  approveJobId: PropTypes.func.isRequired,
  apiServerUrl: PropTypes.string.isRequired,
  pristine: PropTypes.bool.isRequired,
  children: PropTypes.node,

  ...missingTimeEntriesModalPropTypes,
});


const JobApprovalPanel = (props) => {
  const {
    tickets,
    job,
    apiServerUrl,
    selectedTicketId,
    selectTicketId,
    approveJobId,
  } = props;

  const {
    showMissingTimeEntriesModal,
    openMissingTimeEntriesModal,
    closeMissingTimeEntriesModal,
  } = props;

  const renderTab = (ticket) => {
    const { id, ticketNumber, state } = ticket;
    const stateMap = {
      reviewed: 'primary',
      unreviewed: 'danger',
    };
    const tabStyle = stateMap[state];
    const handleClick = () => { selectTicketId(id); };
    return (
      <NavItem key={id} eventKey={id} onClick={handleClick}>
        <Label bsStyle={tabStyle}>{ticketNumber.number}</Label>
      </NavItem>
    );
  };

  const handlePdfDownload = () => {
    const pdfUrl = linkWithCredentials(`${apiServerUrl}${job.pdf_path}`);
    downloadingFileAndUpdatingCredentials(pdfUrl);
  };

  const handleApprovingJobId = async () => {
    const { hasTimeEntries } = job;

    if (hasTimeEntries) {
      approveJobId();
    } else {
      openMissingTimeEntriesModal();
    }
  };

  return (
    <div>
      <Nav bsStyle="tabs" activeKey={selectedTicketId}>
        {tickets.map(renderTab, this)}
      </Nav>
      {/* FIXME: pull panel-tabbed class out to App.css */}
      <div className="panel panel-default panel-tabbed">
        {props.children}
        <div className="panel-footer">
          <Clearfix>
            <ButtonToolbar className="pull-left">
              <Button bsStyle="info" onClick={handlePdfDownload}>
                <Glyphicon glyph="export" style={{ marginRight: '0.5em' }} />
                Export Tickets as PDF
              </Button>
            </ButtonToolbar>
            <ButtonToolbar className="pull-right">
              <Button bsStyle="primary" onClick={handleApprovingJobId}>
                <Glyphicon glyph="envelope" style={{ marginRight: '0.5em' }} />
                Send to Manager
              </Button>
            </ButtonToolbar>
          </Clearfix>
        </div>
      </div>
      <MissingTimeEntriesModal
        title="Missing Time Entries"
        message="Missing Time Entries on Job"
        show={showMissingTimeEntriesModal}
        onHide={closeMissingTimeEntriesModal}
        onSubmit={approveJobId}
      />
    </div>
  );
};


JobApprovalPanel.propTypes = propTypes;

const mapStateToProps = (state) => {
  const { pristine } = getFormState(state);
  return {
    pristine,
  };
};

const withRedux = connect(mapStateToProps, {});

const enhance = compose(
  withRedux,
  withMissingTimeEntriesModalState,
);

export default enhance(JobApprovalPanel);
